import React, {Component} from 'react';
import {Select} from 'antd';

class EditableCellNumber extends Component {

    constructor(props) {
        super(props);
        this.state = {
            object: props.row,
            value: props.row[props.fieldName] || "",
            options: props.options || ""
        };
    }

    focus = () => {
        document.querySelector('.ant-select-selection').focus();
    }

    updateData = () => {
        this.props.onUpdate(this.state.value);
    }

    cancel = () => {
        this.props.onUpdate(this.props.row[this.props.fieldName]);
    }

    handleChange = (value) => {
        this.setState({value: value});
    }

    render() {
        const value = this.state.value;
        const options = this.state.options.selectOptions;
        const children = [];
        for (var i = 0; i < options.length; i++) {
            children.push(<Select.Option key={options[i]}>{options[i]}</Select.Option>);
        }
        return (
            <div className="editable-cell">
                <div className="editable-cell-input-wrapper">
                    <Select ref='inputSelectRef' defaultValue={value} style={{width: 120}} onChange={this.handleChange} onBlur={this.updateData}>
                        {children}
                    </Select>
                </div>
            </div>
        );
    }
}
export default EditableCellNumber;


// WEBPACK FOOTER //
// ./src/modules/dashboard/alert-configuration/EditableCellSelect.js